import React, { useState } from "react";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";

const RejectModal = ({
  isOpen,
  onClose,
  onSubmit,
  setIsMessageBoxVisible,
  setMessageBox,
  setActiveImg,
}) => {
  const [tempComment, setTempComment] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!tempComment.trim()) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please type reason for Edit in question</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }
    onSubmit(tempComment);
    setTempComment(""); // Clear after submit
  };

  const handleClose = () => {
    setTempComment(""); // Clear on cancel too
    onClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 50,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          height: "280px",       
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h2 style={{ marginBottom: "15px", color: "#6A6A6A" }}>
          Reason for Edit Request?
        </h2>

        <textarea
          value={tempComment}
          onChange={(e) => setTempComment(e.target.value)}
          placeholder="Enter Edit request reason..."
          style={{
            flex: 1,             // ✅ Fills available space inside fixed modal
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            resize: "none",      // ✅ Prevent manual resize from breaking layout
            boxSizing: "border-box",
            fontFamily: "inherit",
            fontSize: "14px",
            outline: "none",
            color: "#6A6A6A",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button className="testreportcard-cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button className="testreportcard-create-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;